import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMedal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#EF8C61"
      d="M20.063 9a8.062 8.062 0 1 0-13.125 6.27v7.23a.563.563 0 0 0 .813.503L12 20.88l4.25 2.124a.562.562 0 0 0 .813-.503v-7.23a8.05 8.05 0 0 0 3-6.27m-15 0A6.938 6.938 0 1 1 12 15.938 6.946 6.946 0 0 1 5.063 9m10.875 12.59-3.688-1.843a.56.56 0 0 0-.502 0L8.063 21.59V16.03a8.04 8.04 0 0 0 7.874 0zM12 14.063a5.062 5.062 0 1 0 0-10.125 5.062 5.062 0 0 0 0 10.125m0-9a3.938 3.938 0 1 1 0 7.875 3.938 3.938 0 0 1 0-7.876"
    />
  </svg>
);
export default SvgMedal;
